/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "us-east-2",

  // ✅ Identity pool for federated roles
  aws_cognito_identity_pool_id: "us-east-2:a1f7694e-a11d-4c7c-adf6-1adfc5053c47",
  aws_cognito_region: "us-east-2",
  aws_user_pools_id: "us-east-2_hYwDEZAT7",
  aws_user_pools_web_client_id: "7cvqse8s1i1lu265nq1i31frqf",

  oauth: {
    domain: "us-east-2klrhitktu.auth.us-east-2.amazoncognito.com",
    scope: ["email", "openid", "profile"],
    redirectSignIn: "http://localhost:3000/",
    redirectSignOut: "http://localhost:3000/",
    responseType: "code"
  },

  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: []
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],

  aws_user_files_s3_bucket: "catering-code-bucket",
  aws_user_files_s3_bucket_region: "us-east-2",

  API: {
    endpoints: [
      {
        name: "CateringAPI",
        endpoint: "https://0lab8hw7af.execute-api.us-east-2.amazonaws.com",
        region: "us-east-2"
      }
    ]
  }
};

export default awsmobile;
